import { hideStr, showStr, showStrNotImp } from "./Config";
import { Geocoder } from "./Geocoder";

export class SearchInput {
    $element;
    $elInput;
    $elButton;
    $elAutosuggest;
    $elUseMyLoc;
    features;
    selectedIndex = 0;
    minChar = 2;
    map;

    geocoderHBD = new Geocoder();

    setId(element) {
        this.$element = element;
        this.$elInput = $(element).find("input:text");
        this.$elButton = $(element).find("button");
        this.$elAutosuggest = $(element).find(".autosuggest");
        return this;
    }

    setMap(map) {
        this.map = map;
        return this;
    }

    build() {
        let timer;
        $(this.$elInput).on("input", () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                this.inputEventFired();
            }, 300);
        });
        $(this.$elInput).on("keydown", (e) => {
            this.clearRoute($(this.$elInput).attr("id"));
            if (
                this.features &&
                this.features.features &&
                this.features.features.length
            ) {
                if (e.keyCode == 9 || e.keyCode == 13) {
                    // tab || enter
                    if (this.selectedIndex !== 0) {
                        $(this.$elAutosuggest)
                            .find("li:nth-child(" + this.selectedIndex + ")")
                            .click();
                    } else {
                        this.search(e);
                    }
                    this.selectedIndex = 0;
                    return;
                } else if (e.keyCode == 38) {
                    //up
                    this.selectedIndex--;
                } else if (e.keyCode == 40) {
                    //down
                    this.selectedIndex++;
                }
                if (this.selectedIndex <= 0) {
                    this.selectedIndex = this.features.features.length;
                }
                if (this.selectedIndex > this.features.features.length) {
                    this.selectedIndex = 1;
                }

                if (e.keyCode == 38 || e.keyCode == 40) {
                    $(this.$elAutosuggest).find("li").removeClass("selected");
                    $(this.$elAutosuggest)
                        .find("li:nth-child(" + this.selectedIndex + ")")
                        .addClass("selected");
                }
            }
        });
        $(this.$elInput).on("focusin", (e) => {
            if (
                $(e.currentTarget).val().length >= this.minChar &&
                $(this.$elAutosuggest).children().length > 0
            ) {
                this.$elAutosuggest.fadeIn();
            }
        });
        $(this.$elInput).on("focusout", (e) => {
            this.$elAutosuggest.fadeOut();
        });
        $(this.$elButton).click((e) => {
            this.search(e);
        });
    }

    clearRoute() {
        return false;
    }

    inputEventFired() {
        let value = $(this.$elInput).val();
        if (value.length >= this.minChar) {
            this.$elAutosuggest.fadeIn();
            this.autosuggestMAPBOX(value);
        } else {
            this.$elAutosuggest.fadeOut();
            this.features = null;
            $(this.$elAutosuggest).children().remove();
        }
        this.selectedIndex = 0;
    }

    search(e) {
        if ($(this.$elInput).val()) {
            e.preventDefault();
            this.map.clearMap({ route: true, pins: true, routepins: true });
            $(this.$elAutosuggest).children().remove();
            $("#search-map-result").children().remove();

            this.geocoderHBD.query(
                {
                    query: $(this.$elInput).val(),
                    center: this.map.getCenter().toString(),
                },
                (data) => {
                    if (data.results.features.length == 1) {
                        this.map.setPin(
                            "destination",
                            data.results.features[0]
                        );
                        this.map.flyMeTo(
                            data.results.features[0].center,
                            null,
                            null,
                            14
                        );
                    } else {
                        data.results.features.forEach((feature, index) => {
                            if ($("#resultbar").is(":hidden")) {
                                $(".sidebar").attr("style", hideStr);
                                $("#searchbar").attr("style", showStr);
                                $("#resultbar").attr("style", showStr);
                                $("button.close").attr("style", showStrNotImp);
                            }

                            feature.properties.id = index + 1;
                            feature.properties.newStyle = true;

                            this.createResult(feature);
                            new Marker()
                                .setType("suggestPin")
                                .setPopup(false)
                                .build(this.map, feature);
                        });
                        this.map.setCoordinates(data.results);
                        this.map.adjustZoom();
                    }
                }
            );
        }
    }

    createResult(feature) {
        let listItem = document.createElement("li");
        listItem.className = "searchSuggest";
        listItem.addEventListener("click", () => {
            this.map.flyMeTo(feature.center, null, null, 14);
        });
        let listrow = document.createElement("div");
        listrow.className = "row";

        let listNumber = document.createElement("div");
        listNumber.className = "col suggestNo customPin";
        listNumber.setAttribute("data-counter", feature.properties.id);
        let listImage = document.createElement("div");
        listImage.className = "hbdpin listSuggestPin";
        listImage.setAttribute("id", "listSuggestPin" + feature.properties.id);

        listNumber.appendChild(listImage);
        let listName = document.createElement("div");
        listName.className = "col suggestDesc";
        listName.innerHTML = feature.place_name.replace(", Österreich", "");

        let listButtons = document.createElement("div");
        listButtons.className = "suggestButtons";
        let listButtonOrig = document.createElement("button");
        listButtonOrig.className = "btn btn-empty btn-sm setRoutePin";
        listButtonOrig.setAttribute("type", "button");
        listButtonOrig.setAttribute("data-poi-action", "origin");
        listButtonOrig.setAttribute("data-point", feature);
        listButtonOrig.innerHTML = '<i class="icon icon-direction"></i> Start';
        listButtonOrig.addEventListener("click", () => {
            this.map.setPin("origin", feature);
            this.map.planRoute.setRouteItem("origin", feature);
            this.map.checkRouteComplete();
        });
        let listButtonDest = document.createElement("button");
        listButtonDest.className = "btn btn-empty btn-sm setRoutePin";
        listButtonDest.setAttribute("type", "button");
        listButtonDest.setAttribute("data-poi-action", "destination");
        listButtonDest.setAttribute("data-point", feature);
        listButtonDest.innerHTML = '<i class="icon icon-direction"></i> Ziel';
        listButtonDest.addEventListener("click", () => {
            this.map.setPin("destination", feature);
            this.map.planRoute.setRouteItem("destination", feature);
            this.map.checkRouteComplete();
        });
        listButtons.appendChild(listButtonOrig);
        listButtons.appendChild(listButtonDest);

        listName.appendChild(listButtons);

        listrow.appendChild(listNumber);
        listrow.appendChild(listName);
        listItem.appendChild(listrow);

        queryEl("#search-map-result").appendChild(listItem);
    }
    itemSelected(feature) {
        $(this.$elInput).val(feature.place_name.replace(", Österreich", ""));
        $(this.$elAutosuggest).children().remove();
        $("#search-map-result").children().remove();
        $(".searchPin").addClass("old");
        this.map.setPin("destination", feature);
        $(".searchPin.old").remove();
        this.map.flyMeTo(feature.center, null, null, 14);

        this.map.planRoute.setRouteItem("destination", feature);
        this.map.checkRouteComplete();
    }
    autosuggestMAPBOX(query) {
        let centerObject = this.map.getCenter();
        let centerString = "";
        if (centerObject.lng) {
            centerString = centerObject["lng"] + "," + centerObject["lat"];
        } else {
            centerString = centerObject.toString();
        }
        $.ajax({
            type: "GET",
            url:
                "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
                query +
                ".json",
            data: {
                country: "at",
                language: "de",
                access_token: this.map.key,
                proximity: centerString,
                autocomplete: true,
            },
            success: (response) => {
                setTimeout(() => {
                    $(this.$elAutosuggest).children().remove();
                    this.features = response;
                    this.features.features.forEach((feature, index) => {
                        feature.place_name = feature.place_name.replace(
                            ", Österreich",
                            ""
                        );
                        this.features.features[index].properties[
                            "marker-symbol"
                        ] = "pin" + (index + 1);
                        let $listItem = $('<li id="' + feature.id + '"/>');
                        $listItem.text(feature.place_name);
                        $listItem.on("click", () => {
                            this.itemSelected(feature);
                        });
                        $(this.$elAutosuggest).append($listItem);
                    });
                }, 250);
            },
            complete: () => {},
        });
    }
}

export class SearchInputRoute extends SearchInput {
    build() {
        super.build();
        this.$elAutosuggest.css({ top: "50px" });
    }
    search() {
        $(this.$elAutosuggest).find("li:first-child").click();
    }

    itemSelected(feature) {
        $(this.$elInput).val(feature.place_name.replace(", Österreich", ""));
        $(this.$elAutosuggest).children().remove();
        $(this.$elAutosuggest).attr("style", hideStr + ";top: 50px");

        this.map.setPin($(this.$elInput).attr("id"), feature);
        this.map.planRoute.setRouteItem($(this.$elInput).attr("id"), feature);
        this.map.checkRouteComplete();
    }
}